<template>
<div>
    <confirmation-popup
        title="Change a customer"
        message=""
        :id="`changeCustomerPopup_${selectedCustomerId}`"
        :showConfirmBtn="true"
        :showCreateBtn="true"
        confirm-btn-text="Confirm"
        :show-cancel-btn="true"
        cancel-btn-text="Cancel"
        @on-confirm="fireEventCustomerChangedFromViewBooking">

        <select-customers
            v-model="customer"
            :can_add="canAddCustomer"
            :can_edit="canEditCustomer"
            :event="event"
            :selected-customer-id="selectedCustomerId"
             view-booking="true">
        </select-customers>

    </confirmation-popup>
</div>
</template>

<script>
import ConfirmationPopup from "@/modules/common/components/ConfirmationPopup.vue";
import {EventBus} from "@/events/event-bus";

export default {
    name: "ChangeCustomerPopup",
    components: {ConfirmationPopup},
    props: {
        customer:{},
        canAddCustomer: false,
        canEditCustomer:false,
        counter:1,
        event:null,
        selectedCustomerId:""
    },
    methods:{
        fireEventCustomerChangedFromViewBooking(){
          //  if(this.counter===1){}

                EventBus.$emit('customerChangedFromViewBooking', this.customer,this.selectedCustomerId)

        }
    }
}
</script>

<style scoped>

</style>